import React from 'react';
import { Modal } from 'semantic-ui-react';
import 'PointOfSale/styles/components/modal.less';
import classNames from 'classnames';
import PropTypes from 'prop-types';

class POSModal extends React.PureComponent {
  mountNode = document.getElementById('app');

  render() {
    const {
      onClose,
      open,
      closeOnDimmerClick,
      header,
      children,
      actions,
      footerAction,
      actionClassName,
      contentClassName,
      headerClassName,
      unMountOnClose,
      ...others
    } = this.props;

    const classes = {
      headerClass: classNames('modal-header', {
        [headerClassName]: headerClassName ? true : false,
      }),
      contentClass: classNames('modal-content', {
        [contentClassName]: contentClassName ? true : false,
      }),
    };

    if (unMountOnClose && !open) {
      return null;
    }

    return (
      <Modal
        open={open}
        className="pos-modal"
        closeOnDimmerClick={closeOnDimmerClick}
        onClose={onClose}
        mountNode={this.mountNode}
        {...others}
      >
        {header && (
          <Modal.Header className={classes.headerClass}>{header}</Modal.Header>
        )}
        <Modal.Content className={classes.contentClass}>
          {children}
        </Modal.Content>
        <Modal.Actions className={actionClassName} onClick={footerAction}>
          {actions}
        </Modal.Actions>
      </Modal>
    );
  }
}

POSModal.propTypes = {
  onClose: PropTypes.func,
  header: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  footerAction: PropTypes.func,
  actions: PropTypes.oneOfType([PropTypes.array, PropTypes.node]),
  actionClassName: PropTypes.string,
  contentClassName: PropTypes.string,
  headerClassName: PropTypes.string,
  closeOnDimmerClick: PropTypes.bool,
  unMountOnClose: PropTypes.bool,
};

export default POSModal;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/common/component/Modal.js